module.exports = __webpack_public_path__ + "static/28-unicorn-in-circle-8f17352687af1e96c99342fbf27af194.png";